"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _generalStore = require("general-store");

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _QueuesStore = _interopRequireDefault(require("crm_data/queues/QueuesStore"));

var _QueuesPlaylistDeps = _interopRequireDefault(require("crm_ui/queues/QueuesPlaylistDeps"));

var _InteractionValidators = require("../common/InteractionValidators");

var InteractionWithQueues = function InteractionWithQueues(Component) {
  var InteractionWithQueuesWrapper =
  /*#__PURE__*/
  function (_PureComponent) {
    (0, _inherits2.default)(InteractionWithQueuesWrapper, _PureComponent);

    function InteractionWithQueuesWrapper(props) {
      var _this;

      (0, _classCallCheck2.default)(this, InteractionWithQueuesWrapper);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InteractionWithQueuesWrapper).call(this, props));
      (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(InteractionWithQueuesWrapper, [{
      key: "handleSave",
      value: function handleSave(interactionRecord, engagement) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _this$props = this.props,
            queues = _this$props.queues,
            onSave = _this$props.onSave;

        if (queues) {
          options.queues = queues;
        }

        return onSave(interactionRecord, engagement, options);
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement(Component, (0, _extends2.default)({}, this.props, {
          onSave: this.handleSave
        }));
      }
    }]);
    return InteractionWithQueuesWrapper;
  }(_PureComponent2.default);

  InteractionWithQueuesWrapper.propTypes = {
    onSave: _propTypes.default.func.isRequired,
    queueData: _reactImmutableProptypes.default.map,
    queues: _reactImmutableProptypes.default.map
  };
  var dependencies = {
    queueData: _QueuesPlaylistDeps.default,
    queues: _QueuesStore.default
  };

  if ((0, _InteractionValidators.userCanViewQueues)()) {
    return (0, _generalStore.connect)(dependencies)(InteractionWithQueuesWrapper);
  }

  return InteractionWithQueuesWrapper;
}; // Adds queueData and queues to interaction props


var _default = InteractionWithQueues;
exports.default = _default;
module.exports = exports.default;